<template>
  <div class="two-col" :style="cssVars">
    <div class="col left">
      <slot name="left"></slot>
    </div>
    <div class="col right">
      <slot name="right"></slot>
    </div>
  </div>
</template>

<script>
/**
 * A two column responsive template that collapses to stacked on small screens
 *
 * The column widths can be set as a fractional ratio (3/1 = 75/25 1/1=50/50)
 * on the component and a gap between the columns in px e.g.
 *      <BaseTwoColLayout :leftFr="3" :rightFr="1" :gap="0">
 *          <template #left></template>
 *           <template #right></template>
 *      </BaseTwoColLayout>
 *
 * Depending on the parent, component may need to be placed in a flex wrapper
 * e.g.
 * .two-col-wrapper {
 *      flex: 1 1 auto;
 *      min-height: 0; /* allow child to shrink/scroll
 *  }
 */
export default {
  name: "BaseTwoColLayout",
  props: {
    /** col width ration e.g. 3/1 = 75/25  fr=fractional*/
    leftFr: { type: Number, default: 1 },
    rightFr: { type: Number, default: 1 },
    /** gap between columns in px */
    gap: { type: Number, default: 16 },
    /** 100% parent height or fill rest flex */
    fillParent: { type: Boolean, default: true },
    /** overflow behaviour of cols */
    overflowX: { type: String, default: "auto" },
    overflowY: { type: String, default: "auto" },
  },
  computed: {
    cssVars() {
      return {
        "--left-fr": `${this.leftFr}fr`,
        "--right-fr": `${this.rightFr}fr`,
        "--gap": `${this.gap}px`,
        "--col-oy": this.overflowY,
        "--col-ox": this.overflowX,
      };
    },
  },
};
</script>

<style scoped>
.two-col {
  display: grid;
  grid-template-columns: minmax(0, var(--left-fr)) minmax(0, var(--right-fr));
  gap: var(--gap);
  box-sizing: border-box;
  height: 100%;
}

/* Stack on small screens */
@media (max-width: 960px) {
  .two-col {
    grid-template-columns: 1fr;
  }
}

.col {
  /* border: 1px solid rgba(0, 0, 0, 0.12); */
  box-sizing: border-box;
  min-width: 0; /* prevent overlap/spill when content wraps */
  min-height: 0; /* prevent overlap/spill when content wraps */
  max-height: 100%;
  display: flex;
  flex-direction: column;
  overflow-y: var(--col-oy);
  overflow-x: var(--col-ox);
}
</style>
